import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import qlab5Icon from '@/assets/icons/qlab-5-icon.png';

export const QlabHeaderIcon = () => {
  return (
    <Link className="flex items-center gap-2 hover:no-underline" href="/">
      <Image src={qlab5Icon} alt="QLab 5 Icon" width={45} height={45} />
      <span className="text-2xl font-bold">QLab</span>
    </Link>
  );
};
